import { ParamHistorical } from '../../../../../shared/types/param';

export interface Submotive3HistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Submotivo 2',
    nestedParent: 'Submotivo 1',
    nestedParent2: 'Motivo',
    nestedParent3: 'Tipo PQR',
};
